// BUILD-046 task 9.39: the app-wide instance of the outcome memory (actionOutcomeMemory.ts) used by TaskActionControls. A Caller change forgets
// every remembered message, so the next Caller is never shown what the previous Caller was told.
import { onCallerChanged } from '../../api/workShared';
import { createOutcomeMemory } from './actionOutcomeMemory';

export const actionOutcomes = createOutcomeMemory();

onCallerChanged(() => actionOutcomes.clear());
